import "./Loader.css";

interface LoaderProps {
	loading: boolean;
	loadingMessage: string;
}

export const Loader = ({ loading, loadingMessage }: LoaderProps) => {
	if (!loading) {
		return null;
	}
	return (
		<div className="loader-panel" role="status">
			<div className="loader"></div>
			{loadingMessage}
		</div>
	);
};
